import React from "react";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useActiveCarPreconfigurationSelector } from "@redux/reducers/deal";

const ChosenPreconfiguration = () => {
  const activePreConfiguration = useActiveCarPreconfigurationSelector();

  return (
    <div className="flex justify-start items-center w-full gap-4">
      <div className="flex size-8 basis-8 shrink-0 grow-0">
        <img
          alt={activePreConfiguration.label}
          className="size-full rounded-full"
          src={getStaticAssetURL(
            `/images/preconfigs/${activePreConfiguration.id}/picker.svg`
          )}
          title={activePreConfiguration.label}
        />
      </div>
      <h1 className="text-2xl/1 text-white font-extrabold lg:text-3xl/tight">
        {activePreConfiguration.label}
      </h1>
    </div>
  );
};

export default ChosenPreconfiguration;
